module.exports = __webpack_public_path__ + "static/media/the-phantom-menace-thumb.9f44074a.png";